"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MzTabItemComponent = (function () {
    function MzTabItemComponent() {
    }
    Object.defineProperty(MzTabItemComponent.prototype, "link", {
        get: function () {
            return this.tabItemId ? this.tabItemId : this.label.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    return MzTabItemComponent;
}());
MzTabItemComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'mz-tab-item',
                template: "<div id=\"{{ link }}\" class=\"{{ class }}\"><ng-content></ng-content></div>",
                styles: [""],
            },] },
];
/** @nocollapse */
MzTabItemComponent.ctorParameters = function () { return []; };
MzTabItemComponent.propDecorators = {
    'active': [{ type: core_1.Input },],
    'class': [{ type: core_1.Input },],
    'disabled': [{ type: core_1.Input },],
    'href': [{ type: core_1.Input },],
    'label': [{ type: core_1.Input },],
    'tabItemId': [{ type: core_1.Input },],
    'target': [{ type: core_1.Input },],
};
exports.MzTabItemComponent = MzTabItemComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/tab/tab-item/tab-item.component.js
// module id = ./node_modules/ng2-materialize/dist/tab/tab-item/tab-item.component.js
// module chunks = vendor